"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _DateFieldPreviewNaked = _interopRequireDefault(require("@sprinx/react-mui-fields/DateFieldPreviewNaked"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ProductImage = _interopRequireDefault(require("@sprinx/react-com/ProductImage"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    },
    image: {
      width: 50,
      height: 50
    },
    location: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1)
    },
    date: {
      width: 'auto',
      marginLeft: 'auto'
    }
  };
}, {
  name: 'SxComProductAvailabilityFieldPreviewWithPopupItem'
});
var mediaSizeMap = {
  mini: 'original',
  small: 'original',
  normal: 'original',
  big: 'original'
};

function ProductAvailabilityFieldPreviewWithPopupItem(_ref) {
  var availability = _ref.availability,
      pClasses = _ref.classes,
      className = _ref.className,
      date = _ref.date,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["availability", "classes", "className", "date"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var displayName = availability.displayName,
      image = availability.image;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
    classes: {
      root: classes.image,
      image: classes.image
    },
    src: image,
    alt: t(displayName),
    mediaSizeMap: mediaSizeMap
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.location
  }, t(displayName)), /*#__PURE__*/_react.default.createElement(_DateFieldPreviewNaked.default, {
    className: classes.date,
    value: date
  }));
}

process.env.NODE_ENV !== "production" ? ProductAvailabilityFieldPreviewWithPopupItem.propTypes = {
  availability: _propTypes.default.shape({
    date: _propTypes.default.string,
    displayName: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    image: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string))
  }).isRequired,
  classes: _propTypes.default.shape({
    date: _propTypes.default.string,
    image: _propTypes.default.string,
    location: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  date: _propTypes.default.instanceOf(Date)
} : void 0;
ProductAvailabilityFieldPreviewWithPopupItem.defaultProps = {
  classes: undefined,
  className: undefined,
  date: undefined
};
var _default = ProductAvailabilityFieldPreviewWithPopupItem;
exports.default = _default;